const globalStyles = {
  "@global": {
    body: {
      margin: 0,
    },
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "Apercu, serif",
      fontWeight: 700,
    },
    h1: {
      fontSize: "calc(44px + 2vmin)",
    },
    p: {
      fontFamily: "WiredMono, sans-serif",
      fontSize: "18px",
      lineHeight: 1.4,
    },
  },
}

export const DURATION = "0.2s"

export default globalStyles
